import { createComponent } from '@carvana/merch-components';

export const Wrapper = createComponent('div', {
  className: 'grid justify-items-start gap-y-4'
});

export const StyledPrice = createComponent('p', {
  className: 'text-[20px] font-bold leading-[24px] text-blue-6 m:tl-header-xl',
  'data-qa': 'hero-header-price'
});

export const OriginalPrice = createComponent('p', {
  className: 'text-grey-5 tl-body-s m:tl-body-m',
  'data-qa': 'hero-header-og-price'
});
